var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SideBarBox" }, [
    _c(
      "div",
      { staticClass: "sideContent" },
      [
        _c(
          "div",
          {
            ref: "open",
            class: _vm.navShow ? "open" : "close",
            staticStyle: { "align-self": "center" },
            on: { click: _vm.spread },
          },
          [
            _c("img", {
              staticClass: "spread",
              attrs: { src: require("images/dic.png") },
            }),
          ]
        ),
        _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.navShow,
                  expression: "navShow",
                },
              ],
              staticStyle: { display: "flex" },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "list",
                  class: { checked: index == _vm.groupcheck },
                  on: {
                    click: function ($event) {
                      return _vm.listClick(item, index)
                    },
                    mouseout: function ($event) {
                      return _vm.hiddenTips(item.name)
                    },
                    mouseover: function ($event) {
                      return _vm.showTips(item.name)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "sideImg",
                    attrs: {
                      src:
                        index == _vm.groupcheck
                          ? item.activeImg
                          : item.inactiveImg,
                    },
                  }),
                  _c("p", { staticClass: "sideName" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }